import type { EmblaCarouselType } from 'embla-carousel';
import { Button } from '@packages/shared/src/ui/Button/Button';
import type { CarouselType } from '../types';

type ArrowProps = {
  embla: EmblaCarouselType;
} & Pick<CarouselType, 'aria'>;

export const Arrows = ({ aria, embla }: ArrowProps) => (
  <>
    {embla?.canScrollPrev() && (
      <Button
        variant="icon-only"
        size="medium"
        className="bg-color-carousel-dot absolute top-1/2 -left-1 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
        onClick={() => embla.scrollPrev()}
        {...(aria?.buttonPrev && {
          'aria-label': aria.buttonPrev,
        })}
      >
        <span className="icon-emp-arrow-medium-left size-4" role="img" />
      </Button>
    )}

    {embla?.canScrollNext() && (
      <Button
        variant="icon-only"
        size="medium"
        className="bg-color-carousel-dot absolute top-1/2 -right-1 size-5 -translate-y-1/2 rounded-full border-none shadow-lg"
        onClick={() => embla.scrollNext()}
        {...(aria?.buttonNext && {
          'aria-label': aria.buttonNext,
        })}
      >
        <span className="icon-emp-arrow-medium-right size-4" role="img" />
      </Button>
    )}
  </>
);
